import { useCallback, useEffect, useState } from 'react';

import { getApiErrorMessage } from '../utils/apiError';
import { getParentStudents } from '../services/parentStudentService';

const useParentStudents = (enabled = true) => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    if (!enabled) {
      setStudents([]);
      setLoading(false);
      setError('');
      return [];
    }

    setLoading(true);
    setError('');

    try {
      const data = await getParentStudents();
      setStudents(Array.isArray(data) ? data : []);
      return data;
    } catch (err) {
      setStudents([]);
      if (err?.response?.status === 401) {
        setError('Your session has expired. Please sign in again.');
      } else {
        setError(getApiErrorMessage(err, 'Unable to load students. Please try again.'));
      }
      return [];
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled) {
      refresh();
    }
  }, [enabled, refresh]);

  return {
    students,
    loading,
    error,
    refresh,
    setStudents,
    setError,
  };
};

export default useParentStudents;
